import React, { createContext, useCallback, useContext, useState } from "react";

interface HubSpotMeetingContextType {
  isHubSpotMeetingOpen: boolean;
  openHubSpotMeeting: () => void;
  closeHubSpotMeeting: () => void;
}

const HubSpotMeetingContext = createContext<HubSpotMeetingContextType | undefined>(undefined);

export const HubSpotMeetingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isHubSpotMeetingOpen, setIsHubSpotMeetingOpen] = useState(false);

  const openHubSpotMeeting = useCallback(() => setIsHubSpotMeetingOpen(true), []);
  const closeHubSpotMeeting = useCallback(() => setIsHubSpotMeetingOpen(false), []);

  return (
    <HubSpotMeetingContext.Provider
      value={{ isHubSpotMeetingOpen, openHubSpotMeeting, closeHubSpotMeeting }}
    >
      {children}
    </HubSpotMeetingContext.Provider>
  );
};

export const useGlobalHubSpotMeeting = () => {
  const context = useContext(HubSpotMeetingContext);

  if (!context) {
    throw new Error("useGlobalHubSpotMeeting must be used within a HubSpotMeetingProvider");
  }

  return context;
};
